<template>
  <div>
    <w-alert v-if="model">
      <slot name="title">{{ title }}</slot>
    </w-alert>

    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'w-blocker',
  props: {
    title: {
      type: String,
      default: 'Najpierw wybierz przez kogo jest składany wniosek'
    },
    model: {
      type: Boolean,
      default: null
    }
  }
};
</script>